import script from "./PlanKanban.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanKanban.vue?vue&type=script&setup=true&lang=js"

import "./PlanKanban.vue?vue&type=style&index=0&id=45dca835&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45dca835"]])

export default __exports__